<template>
    <Modal title="למי תרצו לשלוח זימון?"
           ref="modal"
           :hideFooter="true">

        <template v-slot:body>



            <div v-if="title">
                {{ title }}
            </div>

            <div v-if="location">
                <i class="fa-solid fa-location-dot"></i>
                &nbsp;
                {{ location }}
            </div>

            <div v-if="date">
                <i class="fa-regular fa-calendar"></i>
                &nbsp;
                {{ $globals.niceDate(date) }}

                <span>
                    יום
                    {{ $globals.dayOfWeekHebrew(date) }}
                </span>

                <span v-if="time">
                    {{ time }}
                </span>

                
            </div>

            <br>

            <div v-for="person in people">

                <div class="mb-2">

                    <img :src="person.pic"
                         onerror="this.src='https://www.mit4mit.co.il/img/biz_placeHolder.png'"
                         class="rounded-circle"
                         style="width: 40px;height: 40px;object-fit: cover;object-position: center;"
                         alt="">

                    {{ person.name }}

                    <span v-if="person.isCrew"
                          style="background:#f4f0fb;color:#ab8ce4;border-radius:10px;padding:2px 8px;font-size:12px;margin-right:4px;">
                        צוות
                    </span>

                </div>


                <div class="row mb-3">
                    <div class="col-6">

                        <label style="user-select: none;cursor:pointer"
                               class="form-label"
                               @click="person.notifyByMail = !person.notifyByMail">


                            <span style="position:relative;top:1px;"
                                  class="planup-checkbox planup-checkbox-purple"
                                  :class="{ checked: person.notifyByMail }">
                                <i class="fa fa-check"></i>
                            </span>


                            שלח זימון במייל
                        </label>


                        <input class="form-control"
                               v-model="person.email">

                        <span class="formErrorText"
                              v-if="person.errors">
                            {{ person.errors.email }}
                        </span>


                    </div>



                    <div class="col-6">

                        <label style="user-select: none;cursor:pointer"
                               class="form-label"
                               @click="person.notifyByWhatsapp = !person.notifyByWhatsapp">


                            <span style="position:relative;top:1px;"
                                  class="planup-checkbox planup-checkbox-purple"
                                  :class="{ checked: person.notifyByWhatsapp }">
                                <i class="fa fa-check"></i>
                            </span>


                            שלח זימון בואצאפ
                        </label>

                        <input class="form-control"
                               type="number"
                               v-model="person.phone">

                        <span class="formErrorText"
                              v-if="person.errors">
                            {{ person.errors.phone }}
                        </span>

                    </div>

                </div>








            </div>











            <!-- EXTRA MAILS -->
            <!-- 
            <div class="col-12"
                 v-show="meeting.isNotifyByMail">
                <div class="mb-3">
                    <label class="form-label">
                        נמענים
                    </label>



                    <Multiselect selectedLabel=""
                                 deselect-label=""
                                 label="name"
                                 track-by="email"
                                 :multiple="true"
                                 placeholder=""
                                 @tag="addNotifyMailAddress"
                                 selectLabel=""
                                 tagPlaceholder=""
                                 :taggable="true"
                                 v-model="meeting.notifyMailAddress"
                                 :options="contactMails">
                    </Multiselect>




                </div>
            </div> -->


            <!-- CLIENT MESSAGE -->
            <div class="mb-3"
                 v-if="hasClients"
                 style="position:relative;">

                <label class="form-label">
                    {{ hasCrew ? 'הודעה אישית ללקוחות' : 'הודעה אישית' }}


                    <span style="color:#ab8ce4;cursor:pointer"
                          @click="$refs.clientMessageTemplatePopup.show()">
                        בחירה מתוך תבניות
                    </span>

                    <span style="color:#ab8ce4;cursor:pointer;margin-right:12px"
                          @click="toggleFieldsPopup('client')">
                        הוסף פרמטר
                    </span>
                </label>


                <TemplateFieldsPopup ref="clientTemplateFieldsPopup"
                                     style="position:absolute;z-index:2;top:24px;right:0"
                                     :sections="templateFieldSections"
                                     @insert="insertVariable('client', $event)"></TemplateFieldsPopup>


                <textarea class="form-control"
                          ref="clientMessageTextarea"
                          v-model="clientMessage"
                          @focus="clientTextareaTouched = true"
                          style="height:100px;"></textarea>


                <MessageTemplatePopup @text="clientMessage = $event"
                                      ref="clientMessageTemplatePopup"></MessageTemplatePopup>


            </div>


            <!-- CREW MESSAGE -->
            <div class="mb-3"
                 v-if="hasCrew"
                 style="position:relative;">

                <label class="form-label">
                    {{ hasClients ? 'הודעה אישית לאנשי צוות' : 'הודעה אישית' }}


                    <span style="color:#ab8ce4;cursor:pointer"
                          @click="$refs.crewMessageTemplatePopup.show()">
                        בחירה מתוך תבניות
                    </span>

                    <span style="color:#ab8ce4;cursor:pointer;margin-right:12px"
                          @click="toggleFieldsPopup('crew')">
                        הוסף פרמטר
                    </span>
                </label>


                <TemplateFieldsPopup ref="crewTemplateFieldsPopup"
                                     style="position:absolute;z-index:2;top:24px;right:0"
                                     :sections="crewTemplateFieldSections"
                                     @insert="insertVariable('crew', $event)"></TemplateFieldsPopup>


                <textarea class="form-control"
                          ref="crewMessageTextarea"
                          v-model="crewMessage"
                          @focus="crewTextareaTouched = true"
                          style="height:100px;"></textarea>

                <div v-if="hasClients && !crewMessage"
                     style="font-size:12px;color:#999;margin-top:4px;">
                    אם תשאירו ריק - אנשי הצוות יקבלו את אותה הודעה כמו הלקוחות
                </div>


                <MessageTemplatePopup @text="crewMessage = $event"
                                      ref="crewMessageTemplatePopup"></MessageTemplatePopup>


            </div>




            <div class="btn btn-primary pull-right"
                 @click="summon()">
                שלח
            </div>

        </template>

    </Modal>
</template>
<script>

import { apiPost } from '../../core/http/axios_api_v2';
import MessageTemplatePopup from '../MessageTemplates/MessageTemplatePopup.vue';
import TemplateFieldsHandler from '../../modules/TemplateFieldsHandler';
import TemplateFieldsPopup from '../Common/TemplateFieldsPopup.vue';


export default {
    name: 'SummonModal',
    data() {

        return {
            people: [],
            title: '',
            location: '',
            date: null,
            time: '',
            endTime: '',
            //the meeting type's name, for {{סוג הפגישה}} ('' when the summon is not about a meeting)
            meetingType: '',
            //the meeting the summon is about, for its links ({{קישור לאישור הפגישה}}...): the meeting form
            //hands the meeting itself - a new one gets its id from the save, by the time שלח is pressed -
            //and an approved booking request its id. null = not about a saved meeting
            meetingRef: null,
            meetingId: null,
            clientMessage: '',
            crewMessage: '',
            event: null,
            contactsForEventParams: [],
            clientTextareaTouched: false,
            crewTextareaTouched: false,
        }

    },

    computed: {

        hasClients() {
            return this.people.some(person => !person.isCrew);
        },

        hasCrew() {
            return this.people.some(person => person.isCrew);
        },

        templateFieldSections() {

            let sections = [{ title: 'פגישה', fields: TemplateFieldsHandler.summonMeetingFields }];

            //the meeting's own link for the customer - only a summon about a meeting has one
            if (this.meetingRef || this.meetingId)
                sections = sections.concat(TemplateFieldsHandler.meetingLinkSections());

            if (this.event)
                sections.push({ title: 'אירוע', fields: TemplateFieldsHandler.eventFields });

            return sections.concat(TemplateFieldsHandler.bookingFieldSections());
        },

        //same sections, but the per-recipient name token reads שם איש הצוות (a crew member is no
        //contact, so the contact's first / last name tokens are not offered to them)
        crewTemplateFieldSections() {

            let contactOnly = [TemplateFieldsHandler.contactFirstNameField, TemplateFieldsHandler.contactLastNameField];

            return this.templateFieldSections.map(section => ({
                title: section.title,
                fields: section.fields
                    .filter(field => contactOnly.indexOf(field) == -1)
                    .map(field => field == 'שם איש הקשר' ? 'שם איש הצוות' : field)
            }));
        }
    },

    methods: {

        //finally using params object!
        show(data) {

            this.people = [];
            this.title = data.title;
            this.location = data.location;
            this.date = data.date;
            this.time = data.time;
            this.endTime = data.endTime;
            this.meetingType = data.meetingType || '';
            this.meetingRef = data.meeting || null;
            this.meetingId = data.meetingId || null;
            this.event = data.event || null;
            this.contactsForEventParams = data.contacts || [];
            this.clientMessage = '';
            this.crewMessage = '';
            this.clientTextareaTouched = false;
            this.crewTextareaTouched = false;

            if (this.$refs.clientTemplateFieldsPopup)
                this.$refs.clientTemplateFieldsPopup.hide();

            if (this.$refs.crewTemplateFieldsPopup)
                this.$refs.crewTemplateFieldsPopup.hide();

            for (let i = 0; i < data?.contacts?.length; i++) {
                this.people.push({
                    name: this.$handlers.customerHandler.getDisplayName(data.contacts[i]),
                    //{{שם פרטי של איש הקשר}} / {{שם משפחה של איש הקשר}} of this recipient
                    firstName: data.contacts[i].firstName || '',
                    lastName: data.contacts[i].lastName || '',
                    //lets the server personalise {{קישור לזימון פגישה}} for this exact contact
                    contactId: data.contacts[i].id,
                    email: data.contacts[i].email,
                    phone: data.contacts[i].phone,
                    pic: this.$handlers.customerHandler.getContactImage(data.contacts[i]),
                    notifyByMail: !!data.contacts[i].email,
                    notifyByWhatsapp: !!data.contacts[i].phone,
                    isCrew: false,
                    errors: {
                        email: null,
                        phone: null
                    }
                });
            }

            for (let i = 0; i < data?.crewMembers?.length; i++) {
                this.people.push({
                    name: data.crewMembers[i].name,
                    email: data.crewMembers[i].email,
                    phone: data.crewMembers[i].phone,
                    pic: this.$handlers.customerHandler.getContactImage(data.crewMembers[i]),
                    notifyByMail: !!data.crewMembers[i].email,
                    notifyByWhatsapp: !!data.crewMembers[i].phone,
                    isCrew: true,
                    errors: {
                        email: null,
                        phone: null
                    }
                });
            }


            //nothing to do
            if (!this.people.length)
                return; 


            this.$refs.modal.show();
        },

        //inserts a {{parameter}} at the caret position in the message textarea of the given group
        insertVariable(target, field) {

            let isCrew = target == 'crew';

            let token = '{{' + field + '}}';
            let textarea = isCrew ? this.$refs.crewMessageTextarea : this.$refs.clientMessageTextarea;
            let touched = isCrew ? this.crewTextareaTouched : this.clientTextareaTouched;
            let message = isCrew ? this.crewMessage : this.clientMessage;

            //if the textarea was never focused, append at the end instead of position 0
            let start = (touched && textarea) ? textarea.selectionStart : message.length;
            let end = (touched && textarea) ? textarea.selectionEnd : message.length;

            let updatedMessage = message.slice(0, start) + token + message.slice(end);

            if (isCrew)
                this.crewMessage = updatedMessage;
            else
                this.clientMessage = updatedMessage;

            this.$nextTick(() => {
                if (!textarea)
                    return;
                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = start + token.length;
            });
        },

        //only one הוסף פרמטר popup open at a time
        toggleFieldsPopup(target) {

            let popup = target == 'crew' ? this.$refs.crewTemplateFieldsPopup : this.$refs.clientTemplateFieldsPopup;
            let otherPopup = target == 'crew' ? this.$refs.clientTemplateFieldsPopup : this.$refs.crewTemplateFieldsPopup;

            if (otherPopup)
                otherPopup.hide();

            if (popup)
                popup.toggle();
        },

        summon() {

            let foundError = false;

            this.people.forEach(person => {

                if (person.notifyByMail) {
                    if (!person?.email?.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
                        person.errors.email = 'נא להזין מייל תקין';
                        foundError = true;
                    }
                }

                if (person.notifyByWhatsapp) {
                    if (!person?.phone?.toString().match(/^\d{9,10}$/) || person?.phone[0] != '0') {
                        person.errors.phone = 'נא להזין טלפון תקין';
                        foundError = true;
                    }
                }
            });


            if (foundError) {
                return;
            }


            //readable date fields for the {{parameter}} replacement on the server
            let dateDisplay = this.$globals.niceDate(this.date);
            let dayOfWeek = this.$globals.dayOfWeekHebrew(this.date);


            this.date.setHours(this.time ? this.time?.split(':')[0] : 8);
            this.date.setMinutes(this.time ? this.time?.split(':')[1] : 0);
            let startDateForSummon = this.date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';

            this.date.setHours(this.endTime ? this.endTime?.split(':')[0] : 23);
            this.date.setMinutes(this.endTime ? this.endTime?.split(':')[1] : 59);
            let endDateForSummon = this.date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';

            let dateForSummon = startDateForSummon + '/' + endDateForSummon;


            //event {{parameter}} values are resolved here on the client and sent as a
            //{hebrew field name: value} map - the server just merges them into its mappings
            let eventFieldValues = this.event
                ? TemplateFieldsHandler.buildFieldMappings(null, this.event, { contacts: this.contactsForEventParams })
                : {};


            //the meeting's links are signed on the server (SummonsService.fillTemplateFields)
            let meetingId = (this.meetingRef && this.meetingRef.id) || this.meetingId || null;

            apiPost('summons', { message: this.clientMessage, crewMessage: this.crewMessage, people: this.people, title: this.title, meetingType: this.meetingType, location: this.location, date: dateForSummon, dateDisplay, dayOfWeek, time: this.time, endTime: this.endTime, eventFieldValues, meetingId })

            this.$refs.modal.hide();

        }
    },
    components: {
        MessageTemplatePopup,
        TemplateFieldsPopup
    }
}
</script>